import React from "react";

const PlatformButton = ({ name, label, avatar, activeAccount, onActiveAccount, comingSoon }) => {
  const handleClick = () => {
    onActiveAccount(name);
  };

  return (
    <div className="relative mr-2">
      <button
        onClick={handleClick}
        className={`flex items-center rounded-lg px-3 py-2 transition-all duration-200 ${
          activeAccount === name
            ? 'bg-[#6D6B85] text-white'
            : 'bg-[#F0EEF7] text-[#6D6B85] hover:bg-[#6D6B85] hover:text-white'
        } ${comingSoon ? 'opacity-75' : ''}`}
      >
        {avatar && (
          <img
            src={avatar}
            className="mr-2 h-5 w-5 rounded-full object-cover"
            alt={label}
          />
        )}
        <span className="text-sm font-medium">{label}</span>
        {comingSoon && (
          <span className="ml-2 rounded-full bg-yellow-200 px-2 py-1 text-xs text-yellow-800">
            Soon
          </span>
        )}
      </button>
    </div>
  );
}

export default PlatformButton
